import React from 'react'
import { Box } from '@mui/material'
import {
  StyledContainer,
  CommentCard,
  CommentHeader,
  ProfileImage,
  CommentContent,
  UserHandle,
  TimeStamp,
  CommentText,
  ReplyButton,
  ReplySection,
  ReplyIcon,
  FilterContainer,
  FilterButton,
} from './Style'
import { Icons } from 'constants/icon'

interface Comment {
  id: string
  userName: string
  profileImage: string
  timestamp: string
  platform: string
  content: string
  isReplied: boolean
  reply?: string
}

const mockComments: Comment[] = [
  {
    id: '1',
    userName: '@THATGUY87',
    profileImage: Icons.profile,
    timestamp: '4 hours ago',
    platform: 'INSTAGRAM',
    content: "I love true crime, I've been looking for new suggestions though!",
    isReplied: false,
  },
  {
    id: '2',
    userName: '@HLLO7',
    profileImage: Icons.profile,
    timestamp: '6 hours ago',
    platform: 'INSTAGRAM',
    content: "I love true crime, I've been looking for new suggestions though!",
    isReplied: false,
  },
  {
    id: '3',
    userName: '@YESM',
    profileImage: Icons.profile,
    timestamp: '8 hours ago',
    platform: 'INSTAGRAM',
    content: "I love true crime, I've been looking for new suggestions though!",
    isReplied: false,
  },
  {
    id: '4',
    userName: '@BLAHBLAH',
    profileImage: Icons.profile,
    timestamp: '10 hours ago',
    platform: 'INSTAGRAM',
    content: "I love true crime, I've been looking for new suggestions though!",
    isReplied: true,
    reply: "I feel the same way, check out our podcast I'm sure you'd love it!",
  },
  {
    id: '5',
    userName: '@D-VERB',
    profileImage: Icons.profile,
    timestamp: '2 days ago',
    platform: 'INSTAGRAM',
    content: "I love true crime, I've been looking for new suggestions though!",
    isReplied: true,
    reply: "I feel the same way, check out our podcast I'm sure you'd love it!",
  },
]

export default function SocialComments(): JSX.Element {
  return (
    <StyledContainer>
      <FilterContainer>
        <FilterButton>LIKES ▼</FilterButton>
        <FilterButton>PLATFORM ▼</FilterButton>
        <FilterButton>CATEGORY ▼</FilterButton>
      </FilterContainer>
      {mockComments.map((comment) => (
        <Box key={comment.id} sx={{ display: 'flex', gap: '21px' }}>
          <ProfileImage src={comment.profileImage} alt="Profile" />
          <CommentCard>
            <CommentHeader>
              <CommentContent>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '16px',
                  }}
                >
                  <UserHandle>
                    <img
                      src={Icons.insta}
                      alt="Instagram"
                      className="platform-icon"
                    />
                    {comment.userName}
                  </UserHandle>
                  <TimeStamp>{comment.timestamp}</TimeStamp>
                </Box>
                <CommentText>{comment.content}</CommentText>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    marginTop: '16px',
                  }}
                >
                  <ReplyButton
                    variant="contained"
                    className={comment.isReplied ? 'replied' : 'no-reply'}
                  >
                    {comment.isReplied ? (
                      <>
                        <ReplyIcon src={Icons.gCheck} alt="Replied" />
                        REPLIED
                      </>
                    ) : (
                      <>
                        REPLY
                        <ReplyIcon src={Icons.wRightArrow} alt="Reply" />
                      </>
                    )}
                  </ReplyButton>
                </Box>
              </CommentContent>
            </CommentHeader>
            {comment.isReplied && comment.reply && (
              <ReplySection>
                <CommentText>{comment.reply}</CommentText>
              </ReplySection>
            )}
          </CommentCard>
        </Box>
      ))}
    </StyledContainer>
  )
}
